import { useQueryClient } from "@tanstack/react-query";
import { BASE_URL } from "lib/utilities/globalConstants";
import PropTypes from "prop-types";
import { UserAuth } from "provider/AuthProvider";
import * as React from "react";
import { toast } from "react-toastify";
import AddExcelModalCard from "../AddExcelModalCard";

function AddExcelModalV2({ text = false, formId, setIsOpening, langIds, experience, isClosed, totalCustomSkills }) {
  const [candidates, setCandidates] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const queryClient = useQueryClient();
  const { user, setWallet } = UserAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    if (!user) return;
    try {
      const response = await fetch(`${BASE_URL}admin/v2/addCandidatesToForm`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.accessToken}`,
        },
        body: JSON.stringify({
          formId: formId,
          candidates: candidates,
          langIds: langIds,
          experience: experience,
        }),
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success(`Added ${data.data.totalCandidates} Candidates to the form.`);
        queryClient.invalidateQueries(["getAllForms"]);
        setWallet({ Coins: data.data.numberOfCoins, Hold: data.data.coins_hold, Spent: data.data.coins_spent });
      } else {
        toast.error("Somthing went wrong while submitting the form. Please try again.");
      }
    } catch (error) {
      toast.error("Somthing went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }
  return (
    !isClosed && <AddExcelModalCard
      text={text}
      handleSubmit={handleSubmit}
      candidates={candidates}
      setCandidates={setCandidates}
      isLoading={isLoading}
      setIsOpening={setIsOpening}
      experience={experience}
      totalCustomSkills={totalCustomSkills}
    />
  );
}

AddExcelModalV2.propTypes = {
  formId: PropTypes.number.isRequired,
  setIsOpening: PropTypes.func.isRequired,
  langIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default AddExcelModalV2;